module.exports = __webpack_public_path__ + "static/media/santa.aef1b3c7.webp";